// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-root-cnm {\n    touch-action: manipulation;\n}\n\n.icon-icon-P1l {\n    fill: var(--fill, none);\n    stroke: var(--stroke, rgb(var(--venia-global-color-text)));\n}\n\n.icon-icon_desktop-C0k {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "icon-root-cnm items-center inline-flex justify-center",
	"icon": "icon-icon-P1l",
	"icon_desktop": "icon-icon_desktop-C0k h-auto w-auto sm_h-[28px] sm_w-[28px]"
};
export default ___CSS_LOADER_EXPORT___;
